module.exports = __webpack_public_path__ + "static/media/Indonesian Society Sheffield.991307a8.png";